import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SnotifyService } from 'ng-snotify';
import { environment } from '../../environments/environment';

@Injectable()
export class MergeService {

  constructor(private http: HttpClient, private snotifyService: SnotifyService) { }

  public merge(merge_From_Id: number, merge_Into_Id: number): Promise<any> {
    return new Promise((resolve, reject) => {

      var mergeCylinderDto = {
        merge_From_Id: merge_From_Id,
        merge_Into_Id: merge_Into_Id
      };

      this.http.put<any>(environment.apiUrl + 'merge/mergeCylinder', mergeCylinderDto).subscribe(data => {
        resolve(data);

      }, error => {
        console.log(error);
        reject();
      });
    });
  }


}
